export const CLEAR_STORE = "Home/CLEAR_STORE";
